require("!!/root/xmpp-web/node_modules/script-loader/addScript.js")(require("!!/root/xmpp-web/node_modules/script-loader/node_modules/raw-loader/index.js!/root/xmpp-web/node_modules/strophejs-plugins/vcard/strophe.vcard.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./~/strophejs-plugins/vcard/strophe.vcard.js
 ** module id = 9
 ** module chunks = 0
 **/